// extracted by mini-css-extract-plugin
module.exports = {"layout":"_82e3db2ea0--layout--jQ0He","desktop":"_82e3db2ea0--desktop--ogsIN","tablet":"_82e3db2ea0--tablet--LX_pR","phone":"_82e3db2ea0--phone--oDf2N"};